import { render, staticRenderFns } from "./CreditDataFormatter.vue?vue&type=template&id=94a2ada4&functional=true"
import script from "./CreditDataFormatter.vue?vue&type=script&lang=js"
export * from "./CreditDataFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports